import React, { useEffect } from "react";

const AdUnit = ({slot, test=false}) => {

  useEffect(() => {
    try {
      (window.adsbygoogle || []).push({});
    } catch {
      // Ads may already have content
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block"}}
      data-ad-client="ca-pub-8622151405171176"
      data-ad-slot={slot}
      data-ad-format="auto"
      data-adtest={test ? "on" : undefined}
      data-full-width-responsive="true"
    />
  );
}


export const SquareAd = () => {
  return (
    <div>
      <AdUnit slot="3993933328" />
    </div>
  );
};


export const HorizontalAd = () => {
  return (
    <div>
      <AdUnit slot="8312452280" />
    </div>
  );
};